import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export default (exportData => ({
  export(data) {
    return http.post('submissions/api/v3/export/submissions', {
      data: Object.assign({}, data, exportData, {
        exportName: data.exportName || exportData.exportName,
        email: '',
        exportFormat: data.format,
        portalId: PortalIdParser.get()
      })
    });
  }
}));